import { render, staticRenderFns } from "./FeedbackFiveStarsHistogram.vue?vue&type=template&id=d3af80f0&"
import script from "./FeedbackFiveStarsHistogram.vue?vue&type=script&lang=js&"
export * from "./FeedbackFiveStarsHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports